import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from './shell/PageHeader';
import { Notice } from './patterns';

/**
 * Rendered when a URL inside the authenticated app matches no route. It is a
 * destination, not an error state: nothing failed, the address simply does
 * not exist, and the reader needs a way onward from here.
 */
const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="pat-page" data-testid="not-found">
      <PageHeader title={t('notFound.title')} />
      <Notice tone="info">{t('notFound.body')}</Notice>
      <p className="mt-3">
        <Link className="pat-btn pat-btn--primary" to="/">{t('notFound.home')}</Link>
      </p>
    </div>
  );
};

export default NotFoundPage;
